import { Skeleton } from "@chakra-ui/react"
import React from "react"
import CloudImageBrowserGrid from "./CloudImageBrowserGrid"

interface Props {}

const CloudImageBrowserLoader: React.FC<Props> = () => {
  return (
    <CloudImageBrowserGrid>
      {Array.from({ length: 20 }).map((_, index) => {
        return (
          <Skeleton
            key={index}
            width="100%"
            height="165px"
            borderRadius="8px"
          />
        )
      })}
    </CloudImageBrowserGrid>
  )
}

export default CloudImageBrowserLoader
